import Grid from '@mui/material/Grid2';

import type { LicenceLimits, LicenceUsage } from '../api/shared';
import { useT } from '../i18n/LanguageContext';

import { UsageMeter } from './UsageMeter';

/** The four licence metrics, usage against limit (BR-08). */
export const UsageMeters = ({ usage, limits }: { usage: LicenceUsage; limits: LicenceLimits }) => {
  const t = useT();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <UsageMeter label={t('licence.metric.companies')} used={usage.companies} limit={limits.companies} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <UsageMeter label={t('licence.metric.subUsers')} used={usage.subUsers} limit={limits.subUsers} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <UsageMeter label={t('licence.metric.products')} used={usage.products} limit={limits.products} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <UsageMeter
          label={t('licence.metric.totalStock')}
          used={usage.totalStock}
          limit={limits.totalStock}
        />
      </Grid>
    </Grid>
  );
};
